"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Zip extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'zip';
        this._siteId = initParams.site_id;
        this._files = (0, util_1.camelArray)(initParams.files);
        this._location = initParams.location;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    get siteId() {
        return this._siteId;
    }
    set files(value) {
        console.error('Do not set objects this way');
    }
    get files() {
        return this._files;
    }
    set location(value) {
        console.error('Do not set objects this way');
    }
    get location() {
        return this._location;
    }
}
exports.default = Zip;
//# sourceMappingURL=zip.js.map